import { Injectable } from '@angular/core';
import { MAT_NATIVE_DATE_FORMATS, MatDateFormats, NativeDateAdapter } from '@angular/material/core';

// Keeps what the ngx date-time pickers showed since the moment adapter (en-GB): day-first dates ("14/10/2026"),
// a 24-hour time ("00:00"), a Monday-first calendar and two-letter weekday names ("Mo").
@Injectable()
export class DateTimeFieldDateAdapter extends NativeDateAdapter {
  constructor() {
    super();
    this.setLocale('en-GB');
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    return style === 'narrow'
      ? super.getDayOfWeekNames('short').map((name) => name.slice(0, 2))
      : super.getDayOfWeekNames(style);
  }

  // Native parsing goes through Date.parse, which reads "09/10/2026" month first; the text is day first.
  override parse(value: unknown, parseFormat?: object): Date | null {
    if (typeof value === 'string') {
      const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:,?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
      if (match) {
        const [, day, month, year, hours = '0', minutes = '0', seconds = '0'] = match;
        const date = new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
        return date.getMonth() === +month - 1 && date.getDate() === +day ? date : this.invalid();
      }
    }
    return super.parse(value, parseFormat);
  }
}

const TIME: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };

export const DATE_TIME_FIELD_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    timeInput: TIME,
    timeOptionLabel: TIME,
  },
};
